import type { ReactNode } from 'react';
import styles from './FormSectionTitle.module.css';

export const FormSectionTitle = ({ children }: { children: ReactNode }) => (
	<div className={styles.title}>{children}</div>
);
